import { FormatPhonePipe } from '../../../../../modules/mapfre-design-library/src/lib/_helpers/_pipes/format-phone.pipe';
import { UploadTypeModalComponent } from '../../../../screens/upload-type-modal/upload-type-modal.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { BillingQuestionComponent } from '../billing-question/billing-question.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { SystemMaintenanceComponent } from '../../../../screens/system-maintenance/system-maintenance.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  ModalOptions,
  AlertService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { PaperlessService } from '../../../../../_services/_iam/paperless.service';
import { PolicyDataService } from '../../../../../_services/my-insurance/data-services/policy-data.service';
import { PolicyDetailsService } from '../../../../../_services/my-insurance/policy-details.service';
import { StorageServiceObservablesService } from '../../../../../_services/storage-service-observables/storage-service-observables.service';
import { Router , RouterModule } from '@angular/router';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { EnrollEftEpayService } from '../../../../../_services/forms/enroll-eft-epay/enroll-eft-epay.service';
import { FlagDataService } from '../../../../../_services/data-services/flag-data.service';
import { FlagResponse } from '@models/flag-response';
import { CompanyService } from '@services/my-insurance/company.service';
import { PolicyBillingUploadService } from '@services/policy-billing-upload.service';
import { DataLayerService } from '@services/data-layer/data-layer.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, SystemMaintenanceComponent, MapfreLoadingComponent, BillingQuestionComponent, MapfreButtonComponent, UploadTypeModalComponent, FormatPhonePipe],
  selector: 'app-billing-sidebar',
  templateUrl: './billing-sidebar.component.html',
})
export class BillingSidebarComponent implements OnInit {
  @Output() unerolledStatus: EventEmitter<any> = new EventEmitter<any>();
  @Input() policy;
  fullCoverage: boolean;
  endEnrollOptionsModal: ModalOptions;
  sendQuestionModal: ModalOptions;
  hideModal: boolean;
  loading = false;
  autoPay: any;
  eft: boolean;
  showMessage: boolean;
  isPaperless: any;
  isAcmic: boolean;
  isLivoPolicy: boolean;
  showCompany: string;
  isEligibleForUpload: boolean;

  constructor(
    private alertService: AlertService,
    private paperlessService: PaperlessService,
    private policyDataService: PolicyDataService,
    private policyDetailsService: PolicyDetailsService,
    private storageServiceObservablesService: StorageServiceObservablesService,
    public router: Router,
    private errorRedirectionService: ErrorRedirectionService,
    private enrollEftEpayService: EnrollEftEpayService,
    private flagDataService: FlagDataService,
    private acmicService: AcmicService,
    private companyService: CompanyService,
    private pbuploadService: PolicyBillingUploadService,
    private dataLayer:DataLayerService
  ) {
    this.endEnrollOptionsModal = new ModalOptions({
      additionalClasses: 'modal-medium cancel-enroll modal-dialog',
      additionalButtonClasses:
        'red-text float-right align-middle flat no-padding no-margin col-auto cross-btn-class',
      animatePosition: 'top',
      buttonCopy: 'MODAL_REMOVAL_TITLE',
      modalId: 'endEnrollModal',
      howManyIconsUsed: 1,
      iconClasses: 'far fa-times-circle',
      modalTranslateCopy: 'MODAL_REMOVAL_TITLE',
      screenReader: true,
      showIcons: true,
      modalName: 'billing_Sidebar_Unenroll',
    });
    this.isLivoPolicy = false;
    this.isEligibleForUpload = false;
  }

  closeModal() {
    this.showMessage = false;
  }

  onShowMessage() {
    this.showMessage = true;
  }
  triggerDatalayer(label:string){
    const event={
        name:'click_link',
        category:'remarked content',
        detail:'manage policy',
        label:label
      }
    this.dataLayer.pushEvent(event);
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.isEligibleForUpload = this.pbuploadService.isMAGWPolicy(this.policy);
    this.isLivoPolicy = this.policy?.policynumber?.policyNumber.length === 10;
    this.companyService.$currentCompany.subscribe((company)=>{
      this.showCompany = company;
    });
    this.flagDataService.$flagDeatils.subscribe((response: FlagResponse) => {
      if (response) {
        this.isPaperless = response.paper;
        this.eft = response.eft;
      }
    });

    const { effDate } = this.policy;
    if (effDate) {
      this.autoPay = this.policyDetailsService.getDayDifference(effDate);
    }
  }

  hideModalAction(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
    }
  }

  hideMainModal(event) {
    if (event) {
      this.hideModal = !this.hideModal;
    }
  }

  cancel(policyid, where): void {
    if (
      (this.policy &&
        this.policy['days_left_to_expire'] &&
        this.policy['days_left_to_expire'] <= 30 &&
        this.policy.policynumber.policyNumber.length === 6 &&
        this.policy.livoPolicy) ||
      this.policy['isNewPolicy']
    ) {
      this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
      window.scroll(0, 0);
    } else {
      const email = this.storageServiceObservablesService.getUserFromStorage();
      if ( where === 'e-pay' ) {
        this.paperlessService
        .cancelPaperlessEPay(this.policy, email)
        .subscribe(
          () => {
            if (policyid.length < 10) {
              this.alertService.error('EPAY_CANCEL');
            }
            this.unerolledStatus.emit(true);
            this.reSync(email);
          },
          (error) => {
            this.unerolledStatus.emit(true);
            this.errorRedirectionService.errorHandler(
              error,
              'PROBLEM_IN_REQUEST_PROCESSING'
            );
          }
        );
      }
    }
  }

  reSync(email): void {
    this.policyDataService.clear();
    this.policyDetailsService.getPolicyDetailsByEmail(email).subscribe(
      () => {
        this.loading = false;
      },
      (error) => {
        this.errorRedirectionService.errorRedirectHandler(error);
      }
    );

    window.scroll(0, 0);
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

  redirectToEnrollment(policyId, type) {
    this.enrollEftEpayService.setPrevEftRoute(this.router.url);
    if (
      (this.policy &&
        this.policy['days_left_to_expire'] &&
        this.policy['days_left_to_expire'] <= 30 &&
        this.policy.policynumber.policyNumber.length === 6 &&
        this.policy.livoPolicy) ||
      this.policy['isNewPolicy']
    ) {
      this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
      window.scroll(0, 0);
    } else {
      if (type === 'ENROLL') {
        this.router.navigate([
          '/billing',
          'paperless',
          'e-pay',
          policyId,
          'enroll',
        ]);
      } else {
        this.router.navigate([
          '/billing',
          'paperless',
          'e-pay',
          policyId,
          'edit-enroll',
        ]);
      }
    }
  }
}
